export default __webpack_public_path__ + "static/media/inovas1.dce81fef.jpg";